module.exports = __webpack_public_path__ + "img/rollback.ab44ad2c.svg";